export default class UserPermissionsModel {
  public canCreate = false
  public canList = false
  public canDelete = false
}
